var map = {
	"./address_image.svg": 86,
	"./aws_logo.png": 87,
	"./cloud_infrastructure.svg": 88,
	"./education.svg": 89,
	"./experience.svg": 90,
	"./feelingProud.png": 25,
	"./fullstack.svg": 91,
	"./github_logo.png": 92,
	"./infosys_logo.png": 93,
	"./navaneeth_profile.png": 94,
	"./nielit.png": 95,
	"./nptel_logo.png": 96,
	"./oracle_logo.png": 97,
	"./programmer.svg": 98,
	"./projects_image.svg": 99,
	"./salesforce_logo.png": 100,
	"./smart_interviews_logo.png": 101,
	"./talksCardBack.svg": 102,
	"./talksCardBackAlt.svg": 103,
	"./tms_junior_logo.png": 104,
	"./tms_school_logo.png": 105,
	"./ui_ux_design.svg": 106,
	"./vardhaman_logo.png": 107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;